"use strict";


import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


//https://codepen.io/pen?template=PwqrzeG

const firstImage = document.querySelector(".fonction__img");
if (firstImage) {
    gsap.set(".fonction__img", { yPercent: -50, xPercent: -50 });
} 

let firstEnter;

gsap.utils.toArray(".projets__fonction").forEach((el) => {
  
    const image = el.querySelector(".fonction__img");

    const setX = gsap.quickTo(image, "x", { duration: 0.4, ease: "power3" }),
          setY = gsap.quickTo(image, "y", { duration: 0.4, ease: "power3" }),
          align = (e) => {
              if (firstEnter) {
                  setX(e.clientX, e.clientX);
                  setY(e.clientY, e.clientY);
                  firstEnter = false;
              } else {
                  setX(e.clientX);
                  setY(e.clientY);
              }
          },
          startFollow = () => document.addEventListener("mousemove", align),
          stopFollow = () => document.removeEventListener("mousemove", align),
          fade = gsap.to(image, {
              autoAlpha: 1,
              ease: "none",
              paused: true,
              duration: 0.1,
              onReverseComplete: stopFollow
          });

    el.addEventListener("mouseenter", (e) => {
        firstEnter = true;
        fade.play();
        startFollow();
        align(e);
    });

    el.addEventListener("mouseleave", () => {
        fade.reverse();
    });
});



// SCROLL GSAP Librairie GSAP + modif avec code fait en cours 

    gsap.registerPlugin(ScrollTrigger);

    const panels = gsap.utils.toArray(".box");



  if (panels.length === 0) {
    
    } 
    else { gsap.to(panels, {
        xPercent: -110 * (panels.length - 1.4),   
        ease: "none",
        scrollTrigger: {
        trigger: ".section--scroll",
        pin: true,
        scrub: 1,
        snap: 1 / (panels.length - 1.4),
        end: () => "+=" + (document.querySelector(".scroll__container").offsetWidth * 1.5),
        invalidateOnRefresh: true,   
        
        }
    });
    }


// code modifier d'un CodePen @Wael Yasmina: https://codepen.io/WaelYasmina/pen/MYwjxQY //aide avec Grok pour le plugin 
/* function animateCounter(selector, duration = 5000) {
    const $el = $(selector);
    const target = parseInt($el.text(), 10);

    $({ Counter: 0 }).animate({ 
        Counter: target 
    }, {
        duration: duration,
        easing: 'linear',
        step: function () {
            $el.text(Math.ceil(this.Counter) + "%");
        }
    });
}

// Lancer les animations (une fois que le DOM est chargé)
$(document).ready(function() {
    animateCounter('#count');
    animateCounter('#count02');
    animateCounter('#count03');
});
 */

//Annimation chiffres 
function animateCounter(selector, duration = 5000) {
    const el = document.querySelector(selector);
    if (!el) return;

    const target = parseInt(el.textContent, 10);
    if (isNaN(target)) return;

    let current = 0;
    const increment = target / (duration / 24); 

    const timer = setInterval(() => {
        current += increment;

        if (current >= target) {
            el.textContent = target + "%";
            clearInterval(timer);
        } else {
            el.textContent = Math.ceil(current) + "%";
        }
    }, 16);
}

//observer 
function handleIntersect(entries, observer) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
           
            animateCounter('#count');
            animateCounter('#count02');
            animateCounter('#count03');

       
            observer.disconnect();
        }
    });
}

function buildThresholdList() {
    return [0.3, 0.5, 0.7, 1.0]; 
}

function createObserver() {
    const options = {
        root: null,
        rootMargin: "0px",
        threshold: buildThresholdList(),
    };

    const observer = new IntersectionObserver(handleIntersect, options);
    
    const statsSection = document.querySelector('.section--stats');
    if (statsSection) {
        observer.observe(statsSection);
    } 
}


document.addEventListener('DOMContentLoaded', () => {
    createObserver();
});





//code réalisé lors d'un cours (CodeKit)

const tabLinks = document.querySelectorAll('.tab__el a');

if (tabLinks) {
    for(let tablink of tabLinks){
        tablink.addEventListener('click', tabTrigger);
    }
}

function tabTrigger(event){
    event.preventDefault();
    const activeLink = document.querySelector('.tab__el--active');
    activeLink.classList.remove('tab__el--active');
    event.currentTarget.parentNode.classList.add('tab__el--active');
    
    const activeTab = document.querySelector('.tab__content--active');
    activeTab.classList.remove('tab__content--active');
    
    const tabSelectId = event.currentTarget.getAttribute('href');
    const tabSelect = document.querySelector(tabSelectId);
    tabSelect.classList.add('tab__content--active');

 }

//DEFFILEMENT INFINIE  https://codepen.io/hexagoncircle/pen/wvmjomb

document.addEventListener("DOMContentLoaded", () => {
    const control = document.getElementById("direction-toggle");
    const marquees = document.querySelectorAll(".marquee");
    const wrapper = document.querySelector(".wrapper");

    control?.addEventListener("click", () => {
        control.classList.toggle("toggle--vertical");
        wrapper.classList.toggle("wrapper--vertical");
        [...marquees].forEach(marquee => marquee.classList.toggle("marquee--vertical"));
    });
});

//FORMULAIRE 

const form = document.querySelector('.formulaire');
const responseDiv = document.querySelector('.response');


if (form && responseDiv) {
    form.addEventListener('submit', function(event) {
        event.preventDefault();        
        form.reset();                  
        
        responseDiv.classList.add('visible'); 
        
        setTimeout(() => {
            responseDiv.classList.remove('visible');
        }, 5000);
    });
}

//Conséquences

document.addEventListener('DOMContentLoaded', () => {

  const overlay = document.getElementById('overlay');
  
  document.querySelectorAll('.menu__container, .menu__container02 , .menu__container03, .menu__container04').forEach(container => {
    container.addEventListener('click', () => {
      const modalId = container.getAttribute('data-modal');

      const modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.add('show');
        overlay.classList.add('show');
        document.body.style.overflow = 'hidden';
      } 
    });
  });

  function closeModals() {
    document.querySelectorAll('.consequences__formation').forEach(modal => {
      modal.classList.remove('show');
    });
    overlay.classList.remove('show');
    document.body.style.overflow = 'visible';
  }


  
  document.querySelectorAll('.close-btn').forEach(btn => {
    btn.addEventListener('click', closeModals);
  });

});